const input =
  'do you think that maybe like, 1 in 10 people could be actually robots?';

export default input;
